<template>
   <div id="ancillaries-container">
      <AncillariesModal :settings="settings" v-if="ancillariesModalStatus" :orderId="pnr.orderId" :pnrId="pnr.id" />

      <SeatMapModal :currency="currency" :pnrId="pnr.id" v-if="SeatMapModalStatus" />
      <span class="ancillaries-header">{{ $t("ancillariesServices_title") }}</span>

      <div class="ancillaries-buttons-wrapper" v-if="0">
         <ul>
            <template v-for="(ancillary, key, index) in ancillaries">
               <li :key="index" @click="handlerTrigger(key)" :class="[ancillary.enabled ? '' : 'is-disabled ']">
                  <div class="ancillary-box-wrapper">
                     <div class="ancillary-box-icon-wrapper">
                        <i class="gts-icon" :class="ancillary.icon"></i>
                     </div>
                     <div class="ancillary-box-info-wrapper">
                        <div>
                           <span class="ancillary-title">{{ ancillary.name }} </span>
                           <!-- <span class="ancillary-title">{{ ancillary.isLoading }} </span> -->
                           <p class="ancillary-description">Extra baggage service allows you to bring more luggage.</p>
                        </div>
                        <div class="ancillary-add-btn-wrapper" v-if="ancillary.enabled">
                           <UIButton className="default" :text="$t('common_add')" :isSpinnerActive="ancillary.isLoading" />
                        </div>
                        <!-- <span class="ancillary-title">{{ ancillary }} </span> -->
                     </div>
                  </div>
               </li>
               <!-- <li :key="index" :class="[ancillary.enabled ? '' : 'is-disableds d-nones', ancillary.isLoading ? 'is-loading' : '']" @click="handlerTrigger(key)">
                  <div class="g-radial-loader-wrapper">
                     <span class="g-radial-loader"></span>
                  </div>
                  <i class="ancillary-icons" :class="ancillary.icon"></i>
                  <span>{{ ancillary.name }}</span>
               </li> -->
            </template>
         </ul>

         <div id="ancillaries-informations">
            <p v-html="handlerRelatedPnrInfosFMT(pnr.pnr)"></p>
            <p>{{ $t("ancillariesServices_relatedPPaymentMethods") }}</p>
         </div>
      </div>
      <div class="ancillaries-buttons-wrapper-v">
         <ul>
            <template v-for="(ancillary, key, index) in ancillaries">
               <li :key="index" @click="handlerTrigger(key)" :class="[ancillary.enabled ? '' : 'is-disabled ']">
                  <div class="ancillary-box-wrapper">
                     <div class="ancillary-box-icon-wrapper">
                        <i class="gts-icon" :class="ancillary.icon"></i>
                     </div>
                     <div class="ancillary-box-info-wrapper">
                        <div>
                           <span class="ancillary-title">{{ ancillary.name }} </span>
                           <!-- <span class="ancillary-title">{{ ancillary.isLoading }} </span> -->
                           <!-- <p class="ancillary-description">Extra baggage service allows you to bring more luggage.</p> -->
                        </div>
                        <div class="ancillary-add-btn-wrapper" :class="ancillary.enabled ? '' : 'invisible'">
                           <UIButton className="default" :text="$t('common_add')" :isSpinnerActive="ancillary.isLoading" />
                        </div>
                        <!-- <span class="ancillary-title">{{ ancillary }} </span> -->
                     </div>
                  </div>
               </li>
               <!-- <li :key="index" :class="[ancillary.enabled ? '' : 'is-disableds d-nones', ancillary.isLoading ? 'is-loading' : '']" @click="handlerTrigger(key)">
                  <div class="g-radial-loader-wrapper">
                     <span class="g-radial-loader"></span>
                  </div>
                  <i class="ancillary-icons" :class="ancillary.icon"></i>
                  <span>{{ ancillary.name }}</span>
               </li> -->
            </template>
         </ul>

         <div id="ancillaries-informations">
            <p v-html="handlerRelatedPnrInfosFMT(pnr.pnr)"></p>
            <p>{{ $t("ancillariesServices_relatedPPaymentMethods") }}</p>
         </div>
      </div>
      <!-- <button @click="handlerAncillariesTrigger">trigger</button> -->
   </div>
</template>

<script>
import { flightModelGenerator } from "@/components/structural/flight/order-detail/ancillaries/helpers/ancillary-reissue.js";
import { generateUuid } from "@/utils.js";
import { flightService } from "@/service/index.js";
import { objectify } from "@/helper/common.js";
// import { GeneratedJSON } from "@/components/seatMap/SeatMapData.js";
import AncillariesModal from "@/components/structural/flight/order-detail/ancillaries/base/AncillariesModal.vue";
import SeatMapModal from "@/components/structural/flight/order-detail/ancillaries/seatmap2/SeatMapModal.vue";
import Popup from "@/gts-popup.js";
import UIButton from "@/components/unitary/Button.vue";
// import { res_validate } from "@/components/widgets/helpers/dummyReissue.js";
export default {
   name: "Ancillaries",
   props: {
      pnr: Object,
      onlineCheckInUrl: String,
      ancillaryChoices: Object,
      passengers: Array,
      currency: String,
   },
   components: {
      AncillariesModal,
      SeatMapModal,
      UIButton,
   },
   data() {
      return {
         ancillariesModalStatus: false,

         settings: {
            //buraya bakılacak
            searchUuid: null,
            // buraya bakılacak ends
            type: null, //bagaj //Divide
            steps: [],
            paxes: [],
            flights: [],
            meals: [],
            wheelchair: [],
            availableType: Number,
            seats: [],
         },
         ancillaries: {
            baggage: {
               name: this.$t("ancillariesServices_baggage"),
               description: this.$t("ancillariesServices_descriptionBaggage"),
               type: 1,
               order: 1,
               icon: "icon-ancillary-c-baggage",
               isLoading: false,
               enabled: this.ancillaryChoices.baggage,
            },
            onlineCheckin: {
               name: this.$t("ancillariesServices_checkIn"),
               description: this.$t("ancillariesServices_descriptionCheckIn"),
               type: 2,
               order: 2,
               icon: "icon-ancillary-c-checkin",
               isLoading: false,
               enabled: this.ancillaryChoices.onlineCheckin,
            },
            divide: {
               name: this.$t("ancillariesServices_divide"),
               description: this.$t("ancillariesServices_descriptionDivide"),
               type: 3,
               order: 3,
               icon: "icon-ancillary-c-divide",
               isLoading: false,
               enabled: this.ancillaryChoices.divide,
            },

            reissue: {
               name: this.$t("ancillariesServices_reissue"),
               description: this.$t("ancillariesServices_descriptionReissue"),
               type: 5,
               order: 5,
               icon: "icon-ancillary-c-reissue",
               isLoading: false,
               enabled: this.ancillaryChoices.reissue,
            },
            seat: {
               name: this.$t("ancillariesServices_seat"),
               description: this.$t("ancillariesServices_descriptionSeat"),
               type: 6,
               order: 6,
               icon: "icon-ancillary-c-seat",
               isLoading: false,
               enabled: this.ancillaryChoices.seat,
            },
            wheelchair: {
               name: this.$t("ancillariesServices_wheelChair"),
               description: this.$t("ancillariesServices_descriptionWheelchair"),
               type: 7,
               order: 7,
               icon: "icon-ancillary-c-wheelchair",
               isLoading: false,
               enabled: this.ancillaryChoices.wheelchair,
            },
            meal: {
               name: this.$t("ancillariesServicesModal_stepMealSelection"),
               description: this.$t("ancillariesServices_descriptionWheelchair"),
               type: 8,
               order: 8,
               icon: "icon-ancillary-c-meal",
               isLoading: false,
               enabled: this.ancillaryChoices.meal,
            },
         },
      };
   },
   created() {
      // this.handlerAncillaryDivide();
   },
   computed: {
      SeatMapModalStatus() {
         const idControl = this.pnr.id == this.$store.state.seatmap.pnr.id;
         return this.$store.state.seatmap.pnr.status && idControl;
      },
      SomeAncillaryIsLoading() {
         return Object.keys(this.ancillaries).some((a) => {
            return this.ancillaries[a].isLoading;
         });
      },
   },
   methods: {
      handlerTrigger(key) {
         if (this.ancillaries[key].enabled && !this.SomeAncillaryIsLoading) {
            switch (key) {
               case "baggage":
                  this.handlerAncillaryBaggage();

                  break;
               case "divide":
                  this.handlerAncillaryDivide();
                  break;
               case "reissue":
                  this.handlerAncillaryReissue();
                  break;
               case "seat":
                  this.handlerAncillarySeat();
                  break;
               case "wheelchair":
                  this.handlerAncillaryWheelChair();
                  break;
               case "meal":
                  this.handlerAncillarySearchMeal();
                  break;
               case "onlineCheckin":
                  var onlineCheckInUrl = this.ancillaryChoices.onlineCheckinUrl;
                  window.open(onlineCheckInUrl, "_blank");
                  break;
               default:
            }
         }
      },
      handlerAncillarySettings(type) {
         this.settings.type = type;

         if (type == 1) {
            this.settings.steps = [{ name: "ancillariesServicesModal_stepSelectBaggage" }, { name: "ancillariesServicesModal_stepPayment" }, { name: "ancillariesServicesModal_stepResult" }];
         }

         if (type == 5) {
            this.settings.steps = [
               { name: "ancillariesServicesModal_stepFlightSelection" },
               { name: "ancillariesServicesModal_stepFlightSearchResult" },
               { name: "ancillariesServicesModal_stepReissuePayment" },
               { name: "ancillariesServicesModal_stepReissueResult" },
            ];
         }
         if (type == 3) {
            this.settings.steps = [{ name: "ancillariesServicesModal_stepDivide" }, { name: "ancillariesServicesModal_stepResult" }];
         }
         if (type == 6) {
            // this.settings.steps = [{ name: "ancillariesServicesModal_stepSeatSelection" }, { name: "ancillariesServicesModal_stepResult" }];
            this.settings.steps = [{ name: "Seat Selection" }, { name: "Result" }];
         }
         if (type == 7) {
            this.settings.steps = [{ name: "ancillariesServicesModal_stepWheelChairSelection" }, { name: "ancillariesServicesModal_stepResult" }];
         }
         if (type == 8) {
            this.settings.steps = [{ name: "ancillariesServicesModal_stepMealSelection" }, { name: "ancillariesServicesModal_stepReissuePayment" }, { name: "Result" }];
         }
      },
      handlerAncillaryDivide() {
         this.ancillaries.divide.isLoading = true;

         // Passenger Data to Array End
         const passengerArray = [];
         this.passengers.map((item) => {
            const rowObj = {
               name: item.passenger.name,
               surname: item.passenger.surname,
               type: item.passenger.type,
               id: item.passenger.id,
               paxIndex: item.passenger.paxIndex,
               parentIndex: item.passenger.parentIndex,
            };
            passengerArray.push(rowObj);
         });
         this.settings.paxes = passengerArray;

         this.handlerAncillarySettings(3);
         this.ancillariesModalStatus = true;
      },
      handlerAncillaryBaggage() {
         this.handlerAncillarySettings(1);
         this.ancillaries.baggage.isLoading = true;

         const query = {
            uuid: generateUuid(),
            pnrId: this.pnr.id,
         };

         flightService.ancillaryBaggages(query).then((res) => {
            if (res.result.success) {
               this.$store.state.order.searchUuid = res.searchUuid;
               this.generatorAncillaryBaggageModel(res);
            } else {
               this.ancillaries.baggage.isLoading = false;
               const title = this.$t(`RESPONSE_${res.result.app}_${res.result.service}_${res.result.code}_${res.result.subCode}_TITLE`);
               const subTitle = this.$t(`RESPONSE_${res.result.app}_${res.result.service}_${res.result.code}_${res.result.subCode}`);
               Popup.info(title, subTitle);
            }
         });
      },
      handlerAncillaryReissue() {
         this.handlerAncillarySettings(5);
         this.ancillaries.reissue.isLoading = true;
         const query = {
            uuid: generateUuid(),
            pnrId: this.pnr.id,
         };

         flightService.ancillaryReissueValidate(query).then((res) => {
            if (res.result.success) {
               this.settings.availableType = res.availableType;
               this.settings.flights = flightModelGenerator(res.flights);
               this.ancillariesModalStatus = true;
            } else {
               const title = this.$t(`RESPONSE_${res.result.app}_${res.result.service}_${res.result.code}_${res.result.subCode}_TITLE`);
               const subTitle = this.$t(`RESPONSE_${res.result.app}_${res.result.service}_${res.result.code}_${res.result.subCode}`);
               Popup.info(title, subTitle);
            }
            setTimeout(() => {
               this.ancillaries.reissue.isLoading = false;
            }, 1000);
         });
      },
      handlerAncillarySeat() {
         this.$store.commit("seatmap/setStatus", { status: true, id: this.pnr.id });
      },
      handlerAncillaryWheelChair() {
         this.ancillaries.wheelchair.isLoading = true;
         const query = {
            uuid: generateUuid(),
            pnrId: this.pnr.id,
         };

         flightService.ancillarySearchWheelChair(query).then((response) => {
            if (response.result.success) {
               this.settings.searchUuid = response.searchUuid;
               this.settings.wheelchair = response.paxes.map((pax) => {
                  return {
                     paxNumber: pax.index,
                     paxId: pax.id,
                     name: `${pax.name} ${pax.surname}`,
                     paxType: this.$options.filters.EFltPaxType(pax.paxType),
                     segments: response.segments.map((segment) => {
                        const paxIndex = pax.index;
                        const offerKey = `${segment.flightIndex}_${segment.segmentIndex}`;

                        return {
                           segmentId: segment.segmentId,
                           segmentIndex: segment.segmentIndex,
                           from: segment.departureAirport,
                           to: segment.arrivalAirport,
                           marketingAirlineCode: segment.operatingAirline,
                           flightCode: segment.flightId,
                           departureDate: segment.departureDateTime,
                           ssrs: {
                              wheelchair: {
                                 hasSelection: response.bookedWheelChairs[paxIndex][offerKey] ? this.$options.filters.EFltSsrWheelchairTypeEnum(response.bookedWheelChairs[paxIndex][offerKey]) : false,

                                 items: response.wheelChairOffers[paxIndex][offerKey].map((item) => {
                                    return {
                                       name: this.$options.filters.EFltSsrWheelchairTypeEnum(item.type),
                                       description: this.$options.filters.EFltSsrWheelchairType(item.type),
                                       identifier: item.identifier,
                                       value: {
                                          paxIndex: paxIndex,
                                          segment: `${segment.flightIndex}_${segment.segmentIndex}`,
                                          type: item,
                                       },
                                    };
                                 }),
                              },
                           },
                        };
                     }),
                  };
               });

               this.ancillariesModalStatus = true;
               this.ancillaries.wheelchair.isLoading = false;
            } else {
               this.ancillaries.wheelchair.isLoading = false;
               Popup.warning(this.$i18n.t("Popup_lblEmptySearch"), this.$i18n.t("Popup_txtWheelChairNotAvailable"), undefined, 10000);
            }
         });

         this.handlerAncillarySettings(7);
      },
      handlerAncillarySearchMeal() {
         this.ancillaries.meal.isLoading = true;
         const query = {
            uuid: generateUuid(),
            pnrId: this.pnr.id,
         };

         flightService.ancillarySearchMeal(query).then((response) => {
            if (response.result.success) {
               this.$store.state.order.searchUuid = response.searchUuid;
               this.settings.searchUuid = response.searchUuid;
               this.settings.meals = response.paxes.map((pax) => {
                  return {
                     paxNumber: pax.index,
                     paxId: pax.id,
                     name: `${pax.name} ${pax.surname}`,
                     paxType: this.$options.filters.EFltPaxType(pax.paxType),
                     segments: response.segments.map((segment) => {
                        const paxIndex = pax.index;
                        const offerKey = `${segment.flightIndex}_${segment.segmentIndex}`;
                        return {
                           segmentId: segment.segmentId,
                           segmentIndex: segment.segmentIndex,
                           from: segment.departureAirport,
                           to: segment.arrivalAirport,
                           marketingAirlineCode: segment.operatingAirline,
                           flightCode: segment.flightId,
                           departureDate: segment.departureDateTime,
                           ssrs: {
                              food: {
                                 hasSelection: response.bookedMeals[paxIndex][offerKey] ? this.$options.filters.EFltSsrMealTypeEnum(response.bookedMeals[paxIndex][offerKey]) : false,
                                 items: response.mealOffers[paxIndex][offerKey].map((item) => {
                                    return {
                                       name: this.$options.filters.EFltSsrMealType(item.type),
                                       description: this.$options.filters.EFltSsrMealTypeEnum(item.type),
                                       // description: "maya",
                                       identifier: item.identifier,
                                       price: item.price,
                                       currency: item.currency,
                                       selected: false,
                                       value: {
                                          paxIndex: paxIndex,
                                          segment: `${segment.flightIndex}_${segment.segmentIndex}`,
                                          type: item,
                                       },
                                    };
                                 }),
                              },
                           },
                        };
                     }),
                  };
               });

               this.ancillariesModalStatus = true;
               this.ancillaries.meal.isLoading = false;
            } else {
               this.ancillaries.meal.isLoading = false;
               Popup.warning(this.$i18n.t("Popup_lblEmptySearch"), this.$i18n.t("Popup_txtMealNotAvailable"), undefined, 10000);
            }
            this.handlerAncillarySettings(8);
         });
      },
      generatorAncillaryBaggageModel(obj) {
         this.settings.paxes = [];
         const genExBaggageSelector = function (objOffers) {
            const selectorArr = [{ name: "Ext. Baggage", value: 0 }];

            if (objOffers != undefined) {
               objOffers.forEach((offer) => {
                  const rowObj = {
                     name: `${obj.baggageOffers[offer].info} - ${obj.baggageOffers[offer].price} ${obj.baggageOffers[offer].currency} `,
                     value: obj.baggageOffers[offer].price,
                     hidden: obj.baggageOffers[offer].key,
                  };
                  selectorArr.push(rowObj);
               });
            }
            return selectorArr;
         };

         //Creating Flight Obj
         const flights = objectify(obj.flights, (f) => f.flightId);

         // Each Pax Loop
         obj.paxes.forEach((pax, index) => {
            const rowObj = {
               name: `${pax.name} ${pax.surname}`,
               paxType: pax.paxType,
               paxId: pax.paxId,
               paxIndex: index + 1,
               flights: {},
            };

            // Each Flight Loop
            Object.keys(pax.baggages).forEach((baggage, baggageIndex) => {
               rowObj.flights[baggageIndex] = {
                  from: flights[baggage].fromAirportCode,
                  to: flights[baggage].toAirportCode,
                  flightId: flights[baggage].flightId,
                  airlineCode: flights[baggage].marketingAirlineCode,
                  baggage: pax.baggages[baggage].baggage + "KG",
                  baggageSelection: 0,
                  extraBaggage: genExBaggageSelector(pax.baggageOffers[baggage]),
               };
            });
            this.settings.paxes.push(rowObj);
         });
         const self = this;
         setTimeout(() => {
            self.ancillariesModalStatus = true;
         }, 1000);
      },
      handlerRelatedPnrInfosFMT(pnr) {
         return this.$t("ancillariesServices_relatedPNRInfos").replace("{PNR}", `<b>${pnr}</b>`);
      },
   },
   watch: {
      SeatMapModalStatus: {
         handler: function (status) {
            if (!status) {
               window.location.reload();
            }
         },
      },
   },
};
</script>

<style lang="scss" scoped>
#ancillaries-container {
   .ancillaries-header {
      font-size: var(--large);
      font-weight: 600;
      margin-bottom: 1.5rem !important;
      display: block;
   }
   .ancillaries-buttons-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      ul {
         display: flex;
         flex-wrap: wrap;
         // gap: 1rem;
         //  width: 856px;

         li {
            width: 33%;
            @media (max-width: 992px) {
               width: 100%;
            }

            &.is-disabled {
               opacity: 0.3;
               filter: grayscale(100%);

               .ancillary-box-wrapper {
                  cursor: not-allowed;
                  box-shadow: none;
                  outline: 4px solid #dcdcdc;

                  &:hover {
                     background-color: transparent;
                     outline: 1.5px solid #e4e7ec;
                  }
               }
            }

            .ancillary-box-wrapper {
               display: flex;
               outline: 3px solid #e6e7ea;
               border-radius: 1rem;
               padding: 1rem 1.5rem;
               margin: 1rem;
               cursor: pointer;
               box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
               // outline: 3px solid var(--secondary);

               &:hover {
                  background-color: #fffbf8;
                  outline-color: var(--secondary);

                  .ancillary-box-icon-wrapper {
                     i {
                        transform: scale(1.1) rotate(-2.5deg);
                     }
                  }
               }

               .ancillary-box-icon-wrapper {
                  // border: 1px solid red;
                  width: 132px;
                  height: 100px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex-shrink: 0;

                  i {
                     width: 100px !important;
                     height: 100px !important;
                     transition: all 0.15s ease-in-out;
                     &.icon-ancillary-c-baggage {
                        width: 110px !important;
                        height: 120px !important;
                        margin-left: -10px;
                     }
                     &.icon-ancillary-c-checkin {
                        width: 118px !important;
                        height: 98px !important;
                        margin-top: -5px;
                     }
                     &.icon-ancillary-c-divide {
                        width: 120px !important;
                        height: 140px !important;
                        margin-left: -25px;
                        margin-top: 10px;
                     }
                     &.icon-ancillary-c-reissue {
                        width: 120px !important;
                        height: 105px !important;
                     }
                     &.icon-ancillary-c-seat {
                        width: 100px !important;
                        height: 105px !important;
                        margin-left: -10px;
                     }
                     &.icon-ancillary-c-wheelchair {
                        width: 100px !important;
                        height: 95px !important;
                        margin-left: -20px;
                     }
                     &.icon-ancillary-c-meal {
                        width: 120px !important;
                        height: 120px !important;
                        margin-left: -20px;
                     }
                  }
               }

               .ancillary-box-info-wrapper {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  width: 100%;
                  .ancillary-title {
                     font-size: 1.125rem;
                     font-weight: 500;
                  }
                  .ancillary-description {
                     opacity: 0.85;
                  }
                  .ancillary-add-btn-wrapper {
                     display: flex;
                     justify-content: flex-end;

                     button {
                        background-color: #363636;
                        background-color: var(--secondary);
                        color: #fff;
                        padding: 0.125rem 1.5rem;
                        border-radius: 8px;
                        font-weight: 600 !important;

                        &:hover {
                           background-color: var(--accent-primary);
                           background-color: #363636;
                        }
                     }
                  }
               }
            }
         }

         // li {
         //    border: 3px solid #e6e6e6;
         //    // border: 3px solid var(--secondary);
         //    border-radius: 1.5rem;
         //    padding: 2rem 0.5rem;
         //    display: flex;
         //    flex-direction: column;
         //    align-items: center;
         //    width: 168px;
         //    box-sizing: content-box;
         //    margin: 0 1rem;
         //    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.025) 0px 2px 4px -1px;
         //    position: relative;
         //    overflow: hidden;
         //    cursor: pointer;
         //    transform: scale(1);
         //    transition-property: transform;
         //    transition-timing-function: ease-in-out;
         //    transition-duration: 0.15s;

         //    &:before {
         //       content: "";
         //       position: absolute;
         //       inset: 0;
         //       background-color: #00fa8090;
         //       background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NCIgaGVpZ2h0PSI1NSIgdmlld0JveD0iMCAwIDU0IDU1Ij4KICA8ZyBpZD0iR3JvdXBfMTEyNzQiIGRhdGEtbmFtZT0iR3JvdXAgMTEyNzQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yKSI+CiAgICA8ZyBpZD0iRWxsaXBzZV8xMzAzIiBkYXRhLW5hbWU9IkVsbGlwc2UgMTMwMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMikiIGZpbGw9IiNmZmYiIHN0cm9rZT0iIzAwZTY4ZSIgc3Ryb2tlLXdpZHRoPSI1Ij4KICAgICAgPGVsbGlwc2UgY3g9IjI3IiBjeT0iMjcuNSIgcng9IjI3IiByeT0iMjcuNSIgc3Ryb2tlPSJub25lIi8+CiAgICAgIDxlbGxpcHNlIGN4PSIyNyIgY3k9IjI3LjUiIHJ4PSIyNC41IiByeT0iMjUiIGZpbGw9Im5vbmUiLz4KICAgIDwvZz4KICAgIDxnIGlkPSJHcm91cF8xMTI2OCIgZGF0YS1uYW1lPSJHcm91cCAxMTI2OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTkuMDUxIDE3KSI+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzExMjkiIGRhdGEtbmFtZT0iTGluZSAxMTI5IiB5Mj0iMjAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkuOTQ5KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDBlNjgyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iNSIvPgogICAgICA8bGluZSBpZD0iTGluZV8xMTMwIiBkYXRhLW5hbWU9IkxpbmUgMTEzMCIgeTI9IjE5Ljg5OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTkuODk4IDEwLjE2KSByb3RhdGUoOTApIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMGU2ODIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI1Ii8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K");
         //       background-repeat: no-repeat;
         //       background-position-y: bottom;
         //       background-position-x: center;
         //       opacity: 0;
         //       transition-property: all;
         //       transition-duration: 0.15s;
         //       transition-timing-function: ease-in-out;
         //    }

         //    &:hover {
         //       transform: scale(1.1);

         //       &:before {
         //          content: "";
         //          position: absolute;
         //          inset: 0;
         //          background-color: #00fa8090;
         //          background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NCIgaGVpZ2h0PSI1NSIgdmlld0JveD0iMCAwIDU0IDU1Ij4KICA8ZyBpZD0iR3JvdXBfMTEyNzQiIGRhdGEtbmFtZT0iR3JvdXAgMTEyNzQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yKSI+CiAgICA8ZyBpZD0iRWxsaXBzZV8xMzAzIiBkYXRhLW5hbWU9IkVsbGlwc2UgMTMwMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMikiIGZpbGw9IiNmZmYiIHN0cm9rZT0iIzAwZTY4ZSIgc3Ryb2tlLXdpZHRoPSI1Ij4KICAgICAgPGVsbGlwc2UgY3g9IjI3IiBjeT0iMjcuNSIgcng9IjI3IiByeT0iMjcuNSIgc3Ryb2tlPSJub25lIi8+CiAgICAgIDxlbGxpcHNlIGN4PSIyNyIgY3k9IjI3LjUiIHJ4PSIyNC41IiByeT0iMjUiIGZpbGw9Im5vbmUiLz4KICAgIDwvZz4KICAgIDxnIGlkPSJHcm91cF8xMTI2OCIgZGF0YS1uYW1lPSJHcm91cCAxMTI2OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTkuMDUxIDE3KSI+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzExMjkiIGRhdGEtbmFtZT0iTGluZSAxMTI5IiB5Mj0iMjAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkuOTQ5KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDBlNjgyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iNSIvPgogICAgICA8bGluZSBpZD0iTGluZV8xMTMwIiBkYXRhLW5hbWU9IkxpbmUgMTEzMCIgeTI9IjE5Ljg5OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTkuODk4IDEwLjE2KSByb3RhdGUoOTApIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMGU2ODIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI1Ii8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K");
         //          background-repeat: no-repeat;
         //          background-position-y: center;
         //          background-position-x: center;
         //          opacity: 1;
         //       }
         //    }

         //    &:first-child {
         //       margin-left: 0 !important;
         //    }
         //    &:last-child {
         //       margin-right: 0 !important;
         //    }

         //    &.is-disabled {
         //       opacity: 0.5;
         //       cursor: not-allowed;
         //       filter: grayscale(100%);
         //       i,
         //       span {
         //          opacity: 0.5;
         //       }

         //       &:before {
         //          opacity: 0 !important;
         //       }
         //    }

         //    .g-radial-loader-wrapper {
         //       display: none;
         //    }
         //    &.is-loading {
         //       .g-radial-loader-wrapper {
         //          position: absolute;
         //          inset: 0 0 0 0;
         //          display: flex;
         //          align-items: center;
         //          justify-content: center;
         //          background-color: #fff;
         //          span.g-radial-loader {
         //             border-color: var(--secondary);
         //             width: 52px;
         //             height: 52px;
         //             border-width: 5px;
         //          }
         //       }
         //    }

         //    i.ancillary-icons {
         //       display: inline-block;
         //       background-repeat: no-repeat;
         //       background-size: contain;
         //       background-position: center center;
         //       width: 86px !important;
         //       height: 80px !important;

         //       &.ancillary-baggage {
         //          background-image: url("data:image/svg+xml;base64,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");
         //       }
         //       &.ancillary-seat {
         //          background-image: url("data:image/svg+xml;base64,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");
         //       }
         //       &.ancillary-food {
         //          background-image: url("data:image/svg+xml;base64,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");
         //       }
         //       &.ancillary-disabled {
         //          background-image: url("data:image/svg+xml;base64,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");
         //       }
         //       &.ancillary-checkin {
         //          background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1Mi4zNDQiIGhlaWdodD0iNzQuNSIgdmlld0JveD0iMCAwIDUyLjM0NCA3NC41Ij48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOTA4LjA4NyAtMTgxNC43NSkiPjxwYXRoIGQ9Ik0yMTE0LjE4MSwxMzMuMjVoLTI1Ljg0NEExMy4yNSwxMy4yNSwwLDAsMSwyMDc1LjA4NywxMjB2LTUuNTg4YTEuMjUsMS4yNSwwLDAsMSwuOTktMS4yMjMsMi43NTEsMi43NTEsMCwwLDAsMC01LjM3OSwxLjI1LDEuMjUsMCwwLDEtLjk5LTEuMjIzVjcyYTEzLjI0OSwxMy4yNDksMCwwLDEsMTMuMjUtMTMuMjVoMjUuODQ0QTEzLjI0OSwxMy4yNDksMCwwLDEsMjEyNy40MzEsNzJ2MzQuNWExLjI1LDEuMjUsMCwwLDEtMS4yNSwxLjI1LDIuNzUsMi43NSwwLDAsMCwwLDUuNSwxLjI1LDEuMjUsMCwwLDEsMS4yNSwxLjI1VjEyMGExMy4yNSwxMy4yNSwwLDAsMS0xMy4yNSwxMy4yNTFabS0zNi41OTQtMTcuOTMzVjEyMGExMC43NSwxMC43NSwwLDAsMCwxMC43NSwxMC43NTFoMjUuODQ0QTEwLjc1LDEwLjc1LDAsMCwwLDIxMjQuOTMxLDEyMHYtNC40YTUuMjUxLDUuMjUxLDAsMCwxLDAtMTAuMlY3MmExMC43NDksMTAuNzQ5LDAsMCwwLTEwLjc1LTEwLjc1aC0yNS44NDRBMTAuNzQ5LDEwLjc0OSwwLDAsMCwyMDc3LjU4Nyw3MnYzMy42ODJhNS4yNSw1LjI1LDAsMCwxLDAsOS42MzVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE2NyAxNzU2KSIgZmlsbD0iI2ZmOTEzMyIvPjxwYXRoIGQ9Ik0xOCwxLjVIMEExLjUsMS41LDAsMCwxLTEuNSwwLDEuNSwxLjUsMCwwLDEsMC0xLjVIMThBMS41LDEuNSwwLDAsMSwxOS41LDAsMS41LDEuNSwwLDAsMSwxOCwxLjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5MjUuNSAxODcwLjQ3NCkiIGZpbGw9IiNmZjkxMzMiLz48cGF0aCBkPSJNMTgsMS41SDBBMS41LDEuNSwwLDAsMS0xLjUsMCwxLjUsMS41LDAsMCwxLDAtMS41SDE4QTEuNSwxLjUsMCwwLDEsMTkuNSwwLDEuNSwxLjUsMCwwLDEsMTgsMS41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTI1LjUgMTg3NykiIGZpbGw9IiNmZjkxMzMiLz48cGF0aCBkPSJNNTAuOTMyLDUwLjcwNyw0OC43OSwzOC44NjZhMS44NDksMS44NDksMCwwLDEsLjQ1Ny0xLjU3MmMxLjQ3OC0xLjYyOCwyLjc4OS0zLjE4Nyw0LjI3Ny00Ljc4N2EyLjU3OCwyLjU3OCwwLDAsMC0zLjU4NC0zLjU4NGMtMS42MjYsMS41MTMtMy4yMTEsMi44NDItNC44NjYsNC4zNDlhMS44NTMsMS44NTMsMCwwLDEtMS40LjQ4MUwzMi4wMTUsMzEuNzg5LDI5LjA2OSwzMy45M2wxMC44NjYsNC45ODEtNC40OSw1LjEwOS00Ljc3OC0uMTg1LTIsMiw2LjAyMSwyLjIsMi4yLDYuMDIsMi0yLS40MTktNS4wMTIsNS4wNTEtNC41NDksNS4yNzIsMTEuMTU3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODc1Ljg4MSAxODQzLjA0Mykgcm90YXRlKC00NSkiIGZpbGw9IiNmZjkxMzMiLz48L2c+PC9zdmc+");
         //       }
         //       &.ancillary-divide {
         //          background-image: url("data:image/svg+xml;base64,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");
         //       }
         //       &.ancillary-reissue {
         //          width: 66px !important;
         //          height: 80px !important;
         //          background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1Ni43NSIgaGVpZ2h0PSI1Ni44MTEiIHZpZXdCb3g9IjAgMCA1Ni43NSA1Ni44MTEiPgogIDxnIGlkPSJyZW5ldyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMuMzc1IC0zLjM1OSkiPgogICAgPHBhdGggaWQ9IlBhdGhfMTEwODIiIGRhdGEtbmFtZT0iUGF0aCAxMTA4MiIgZD0iTTIxLjk2MiwxOC42NjlIMTAuNTY5QTI0LjAxLDI0LjAxLDAsMCwxLDU0LjcsMzEuNzY1aDQuMzY1QTI4LjM3NSwyOC4zNzUsMCwwLDAsOC44NjUsMTMuNlY1LjU3M0g0LjVWMjMuMDM0SDIxLjk2MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDU4KSIgZmlsbD0iI2ZmOTEzMyIvPgogICAgPHBhdGggaWQ9IlBhdGhfMTEwODMiIGRhdGEtbmFtZT0iUGF0aCAxMTA4MyIgZD0iTTQwLjQ4MSwzMS4xSDUxLjg3M0EyNC4wMSwyNC4wMSwwLDAsMSw3Ljc0LDE4SDMuMzc1YTI4LjM3NSwyOC4zNzUsMCwwLDAsNTAuMiwxOC4xNnY4LjAzMmg0LjM2NVYyNi43MzFINDAuNDgxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxMy43NjUpIiBmaWxsPSIjZmY5MTMzIi8+CiAgPC9nPgo8L3N2Zz4K");
         //       }
         //       &.ancillary-wheelchair {
         //          background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NC45NiIgaGVpZ2h0PSI3NSIgdmlld0JveD0iMCAwIDU0Ljk2IDc1Ij4KICA8ZyBpZD0iU3VpdGFibGU0RGlzYWJsZWQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMC41IC0xNTMuNSkiPgogICAgPHBhdGggaWQ9IlBhdGhfOTc1OCIgZGF0YS1uYW1lPSJQYXRoIDk3NTgiIGQ9Ik0xOS4wNDEsMjQuNjc0djE2LjM5YTUuNjIzLDUuNjIzLDAsMCwxLTUuNzcxLDUuNDYzQTUuNjIzLDUuNjIzLDAsMCwxLDcuNSw0MS4wNjVWMjEuMDMyYzAtMi4yMTgsNy42OTQtOS4xMDYsNy42OTQtOS4xMDZoOS42MThzNC43ODcsMy43MTYsNS43NzgsOS4yNDEtMS44MTMsMTIuODU3LTEuODEzLDEyLjg1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzYuMDQxIDE2NS4wNzQpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZjkxMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIzIi8+CiAgICA8cGF0aCBpZD0iUGF0aF85NzU5IiBkYXRhLW5hbWU9IlBhdGggOTc1OSIgZD0iTTIwLjM3OCwzMy43NzVsNi4zLDExLjM2NmE1LjY3NSw1LjY3NSwwLDAsMCw3LjgzMiwyLjEzNSw1LjksNS45LDAsMCwwLDIuMS03Ljk3N0wyOS44MywyNUgxOC41IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0Ni41NjMgMTc1LjIwMykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmOTEzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzk3NTciIGRhdGEtbmFtZT0iUGF0aCA5NzU3IiBkPSJNMzMsMTIuNWExMSwxMSwwLDEsMS0xMS0xMSwxMSwxMSwwLDAsMSwxMSwxMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM4LjMwNiAxNTMuNSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmOTEzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzk3NjAiIGRhdGEtbmFtZT0iUGF0aCA5NzYwIiBkPSJNMjQuMDksMjEuMjQ3YTE3LjgyMiwxNy44MjIsMCwwLDEsMTIuMDM0LDE2LjcsMTcuMzEyLDE3LjMxMiwwLDAsMS0zNC42MjQsMEExNy41LDE3LjUsMCwwLDEsMTMuMTM0LDIxLjYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMwLjUgMTcxLjczNykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmOTEzMyIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIzIi8+CiAgPC9nPgo8L3N2Zz4K");
         //       }
         //    }
         //    span {
         //       font-weight: 500;
         //       font-size: var(--large);
         //       color: var(--txt-gray);
         //       margin-top: 1rem;
         //    }
         // }
      }
   }
   .ancillaries-buttons-wrapper-v {
      display: flex;
      flex-direction: column;
      align-items: center;

      ul {
         display: flex;
         flex-wrap: wrap;
         @media (max-width: 576px) {
            justify-content: center;
         }
         li {
            min-width: 20%;

            &.is-disabled {
               opacity: 0.3;
               filter: grayscale(100%);

               .ancillary-box-wrapper {
                  cursor: not-allowed;
                  box-shadow: none;
                  outline: 4px solid #dcdcdc;

                  &:hover {
                     background-color: transparent;
                     outline: 1.5px solid #e4e7ec;

                     .ancillary-box-icon-wrapper {
                        i {
                           transform: none !important;
                        }
                     }
                  }
               }
            }

            .ancillary-box-wrapper {
               display: flex;
               flex-direction: column;
               align-items: center;
               outline: 3px solid #e6e7ea;
               border-radius: 1rem;
               padding: 1rem 1.5rem;
               margin: 1rem;

               &:hover {
                  background-color: #fffbf8;
                  outline-color: var(--secondary);

                  .ancillary-box-icon-wrapper {
                     i {
                        transform: scale(0.85) rotate(-2.5deg);
                     }
                  }
               }
               .ancillary-box-icon-wrapper {
                  // border: 1px solid red;
                  width: 132px;
                  height: 100px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex-shrink: 0;

                  i {
                     width: 100px !important;
                     height: 100px !important;
                     transition: all 0.15s ease-in-out;
                     transform: scale(0.75);
                     &.icon-ancillary-c-baggage {
                        width: 110px !important;
                        height: 120px !important;
                        margin-left: -10px;
                     }
                     &.icon-ancillary-c-checkin {
                        width: 118px !important;
                        height: 98px !important;
                        margin-top: -5px;
                     }
                     &.icon-ancillary-c-divide {
                        width: 120px !important;
                        height: 140px !important;
                        margin-left: -25px;
                        margin-top: 10px;
                     }
                     &.icon-ancillary-c-reissue {
                        width: 120px !important;
                        height: 105px !important;
                     }
                     &.icon-ancillary-c-seat {
                        width: 100px !important;
                        height: 105px !important;
                        margin-left: -10px;
                     }
                     &.icon-ancillary-c-wheelchair {
                        width: 100px !important;
                        height: 95px !important;
                        margin-left: -20px;
                     }
                     &.icon-ancillary-c-meal {
                        width: 115px !important;
                        height: 120px !important;
                        margin-top: 8px;
                        margin-left: -4px;
                     }
                  }
               }
               .ancillary-box-info-wrapper {
                  // display: flex;
                  // flex-direction: column;
                  // justify-content: space-between;
                  // width: 100%;
                  .ancillary-title {
                     display: block;
                     width: 100%;
                     text-align: center;
                     font-size: 1.2rem;
                     font-weight: 500;
                     margin-bottom: 1rem;
                  }
                  .ancillary-description {
                     opacity: 0.85;
                  }
                  .ancillary-add-btn-wrapper {
                     display: flex;
                     width: 100%;
                     justify-content: center;

                     button {
                        background-color: #363636;
                        background-color: var(--secondary);
                        color: #fff;
                        padding: 0.125rem 1.5rem;
                        border-radius: 8px;
                        font-weight: 600 !important;

                        &:hover {
                           background-color: var(--accent-primary);
                           background-color: #363636;
                        }
                     }
                  }
               }
            }
         }
      }
   }
}
</style>

<style lang="scss">
#ancillaries-informations {
   border-top: 1px dashed #cacaca;
   padding: 1.25rem 0;
   margin-top: 1.25rem;
   //width: 856px;
   text-align: center;
   b {
      font-weight: 600;
   }
}
</style>
